import { SvgIcon } from '@mui/material';

const Account = props => (
  <SvgIcon {...props} viewBox='0 0 35 36'>
    <path
      d='M19.0441 17.8544C18.8367 17.8544 18.6405 17.7272 18.5623 17.5219C18.4619 17.2563 18.5953 16.9588 18.8614 16.8584C20.3792 16.2835 21.3597 14.8706 21.3597 13.2591C21.3597 11.1302 19.6283 9.39877 17.4994 9.39877C15.3706 9.39877 13.6392 11.1302 13.6392 13.2591C13.6392 14.8706 14.6197 16.283 16.1375 16.8584C16.4031 16.9593 16.5369 17.2563 16.4366 17.5224C16.3362 17.7885 16.0382 17.9218 15.7726 17.8214C13.8811 17.1044 12.6097 15.2716 12.6097 13.2596C12.6097 10.5635 14.8034 8.36987 17.4994 8.36987C20.1955 8.36987 22.3892 10.5635 22.3892 13.2596C22.3892 15.2716 21.1178 17.1049 19.2258 17.8214C19.1661 17.8435 19.1048 17.8544 19.0441 17.8544Z'
      fill='black'
      fillOpacity='0.56'
    />
    <path
      d='M25.2205 27.6306C24.9359 27.6306 24.7058 27.4005 24.7058 27.1159C24.7058 23.1424 21.4735 19.91 17.4999 19.91C15.8066 19.91 14.161 20.5091 12.8671 21.5967C11.2319 22.971 10.2941 24.9825 10.2941 27.1159C10.2941 27.4005 10.0635 27.6306 9.77935 27.6306C9.49524 27.6306 9.26465 27.4005 9.26465 27.1159C9.26465 24.6783 10.3363 22.3791 12.2041 20.8087C13.6839 19.5652 15.5641 18.8806 17.4999 18.8806C22.0407 18.8806 25.7352 22.5752 25.7352 27.1159C25.7352 27.4005 25.5052 27.6306 25.2205 27.6306Z'
      fill='#DC0032'
    />
  </SvgIcon>
);

export default Account;
